import { render, staticRenderFns } from "./MdHomeNew.vue?vue&type=template&id=3bf752db&scoped=true&"
import script from "./MdHomeNew.vue?vue&type=script&lang=js&"
export * from "./MdHomeNew.vue?vue&type=script&lang=js&"
import style0 from "./MdHomeNew.vue?vue&type=style&index=0&id=3bf752db&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bf752db",
  null
  
)

export default component.exports